<router-outlet></router-outlet>
<!-- <app-databridge></app-databridge> -->

<!-- Skipper, available on every signed-in page: tucked at an edge, draggable, tap to open -->
<app-skipper-floating-companion></app-skipper-floating-companion>

<!-- Learning Center: revisitable list of feature tours (opened from profile) -->
<app-learning-center></app-learning-center>
<!-- Guided-tour spotlight overlay + completion dialog (always mounted, render when a tour is active) -->
<app-tour-overlay></app-tour-overlay>
<app-tour-completion-dialog></app-tour-completion-dialog>

<!-- Can I Keep It regulations sheet + Skipper popout host -->
<app-keep-it-host></app-keep-it-host>

<!-- Single app-wide toast host, driven by ToastService -->
<lib-snackbar
  [message]="toast.message()"
  [type]="toast.type()"
  [show]="toast.show()"
  [duration]="toast.duration()"
  [autoClose]="true"
  (onClose)="toast.dismiss()"
  (onAutoClose)="toast.dismiss()">
</lib-snackbar>